import Vue from 'vue'

export async function getActividades(context, [access_token, showload]) {
    try {
        
        if (showload){
          context.commit('setLoading', true, { root: true })
        }
        const response = await Vue.axios({
            method: 'GET',
            url: '/actividades',
            headers: {
                //  'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + access_token,
            },
            

        })
       
        context.commit('act/setActividades', response.data, { root: true })
    } catch (e) {
    } finally {
        if (showload){
            context.commit('setLoading', false, { root: true })
        }
    }
}



export async function updateActividad(context, [access_token, act, mat]) {
    try {
        context.commit('setLoading', true, { root: true })
        const response = await Vue.axios({
            method: 'PATCH',
            url: '/actividades/' + act.id,
            headers: {
                //'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + access_token,
            },
            data: {
                actividad: act,
                materiales: mat
               
            }
        })
        if (response.status == 200) {
            context.commit('act/actListActividades', response.data, { root: true })
            return response.data
        }
    } catch (e) {
      
    } finally {
        context.commit('setLoading', false, { root: true })
    }
}




export async function createActividad(context, [access_token, act]) {
    try {
        context.commit('setLoading', true, { root: true })
        const response = await Vue.axios({
            method: 'POST',
            url: '/actividades',
            headers: {
                //'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + access_token,
            },
            data: {
               
                actividad: act,
               
                
            }
        })
        if (response.status == 200) {
          //  context.commit('act/actListActividades', response.data, { root: true })
            return response.data
        }
       
    } catch (e) {
        console.log(e)
    } finally {
        context.commit('setLoading', false, { root: true })
    }
}



export async function deleteActividad(context, [access_token, id]) {
    try {
        context.commit('setLoading', true, { root: true })
        const response = await Vue.axios({
            method: 'POST',
            url: '/actividaddelete',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + access_token,
            },
            data: {
                id: id,
            }
        })
       
        if (response.status == 201) {
            context.commit('act/actDeleteListActividades', id, { root: true })
            return response;
        }
       
    } catch (e) {
       return null;
    } finally {
        context.commit('setLoading', false, { root: true })
    }
}